import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDestino } from './interfaces/destino.interface';
import { DestinoService } from './services/destino.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-destino-form',
  templateUrl: './destino-form.component.html'
})
export class DestinoFormComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<{refresh: boolean, clave?: string, success?: boolean}>();
  @Input() model: IDestino | null = null;

  form: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private destinoService: DestinoService,
    private dialog: MatDialog
  ) {
    this.form = this.fb.group({
      destino: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.setForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && changes['model'].currentValue) {
      this.setForm();
    } else if (changes['visible'] && changes['visible'].currentValue) {
      if (this.model) {
        this.loadDestinoByClave(this.model.destino);
      } else {
        this.form.reset();
        this.form.controls['destino'].enable();
      }
    }
  }

  setForm(): void {
    if (this.model) {
      this.loadDestinoByClave(this.model.destino);
    } else {
      this.form.reset();
      this.form.controls['destino'].enable();
    }
  }

  loadDestinoByClave(clave: string) {
    this.loading = true;
    this.destinoService.getDestinoByClave(clave).subscribe({
      next: (res) => {
        if (res.success && res.data.length > 0) {
          const destino = res.data[0];
          this.form.patchValue({
            destino: destino.destino,
            descripcion: destino.descripcion
          });
          this.form.controls['destino'].disable();
        }
      },
      complete: () => this.loading = false
    });
  }

  create() {
    if (this.form.valid) {
      this.loading = true;
      const payload = {
        que: 1,
        tope: '',
        clave: this.form.get('destino')?.value,
        descripcion: this.form.get('descripcion')?.value
      };
      this.destinoService.getDestinosVar(payload).subscribe({
        next: (res) => {
          if (res.success && res.data?.error === '0') {
            this.visible = false;
            this.visibleChange.emit({refresh: true, clave: payload.clave, success: true});
          } else {
            this.visible = false;
            this.visibleChange.emit({refresh: false, clave: payload.clave, success: false});
          }
        },
        error: () => {
          this.visible = false;
          this.visibleChange.emit({refresh: false, clave: payload.clave, success: false});
        },
        complete: () => this.loading = false
      });
    }
  }

  update() {
    if (this.form.valid && this.model) {
      this.loading = true;
      const payload = {
        que: 2,
        tope: '',
        clave: this.model.destino,
        descripcion: this.form.get('descripcion')?.value
      };
      this.destinoService.getDestinosVar(payload).subscribe({
        next: (res) => {
          if (res.success && res.data?.error === '0') {
            this.visible = false;
            this.visibleChange.emit({refresh: true, clave: payload.clave, success: true});
          } else {
            this.visible = false;
            this.visibleChange.emit({refresh: false, clave: payload.clave, success: false});
          }
        },
        error: () => {
          this.visible = false;
          this.visibleChange.emit({refresh: false, clave: payload.clave, success: false});
        },
        complete: () => this.loading = false
      });
    }
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'destinos',
        sClave: `${this.form.get('destino')?.value}`,
        sNombre: this.form.get('descripcion')?.value,
        sTipo: 'Opcion'
      }
    });
  }

  close(refresh: boolean = false) {
    this.visible = false;
    this.visibleChange.emit({refresh});
  }
} 